import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EntidadEmpresarialEntity } from './servicio-entidad.service';
import { LoginEntity } from '../interfaces/login';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import EmpresasEntity from '../classes/EmpresasEntity';

@Injectable({
  providedIn: 'root'
})
export class ServicioFormatoAsistencialService {

  valoresPregunta: ValorPreguntaEntity[] = [];

  nodosCompletos: NodoEntity[] = [];

  datosCompletos: DatoEntity[] = [];

  temporalNodos = new BehaviorSubject(null);

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor( private requestUrl: ReportesRequestService, private http: HttpClient) { }

  // Servicios

  async getInformacionLogin(codigoBaseDatos: string, login: number) {
    try {
      const request = await this.requestUrl.getRequest('login/info', [ codigoBaseDatos, { uncoLogin : login }]);
      return request;
    } catch (e) {
      console.error('ServicioFormatoAsistencialService.getInformacionLogin()', e);
    }
  }

  async getEspecialidadesByAdmision(codigoBaseDatos: string, admision: number) {
    try {
      return await this.requestUrl.getFilterRequest('formato-asistencial/especialidades-admision', [ codigoBaseDatos, { admision : admision }]);
    } catch (e) {
      console.error('ServicioFormatoAsistencialService.getEspecialidadesAdmision()', e);
    }
  }

  async getEmpresasByAdmision(codigoBaseDatos: string, admision: number) {
    try {
      return this.requestUrl.getFilterRequest('formato-asistencial/empresas-admision', [codigoBaseDatos, { admision: admision }])
        .pipe(
          map((data: EmpresaEntity[]) => {
            const lista: EmpresaEntity[] = [];
            if (data && data.length > 0) {
              data.forEach((e: EmpresasEntity) => {
                const emp = new EmpresasEntity();
                emp.unco = e.unco;
                emp.descripcionCorta = e.descripcionCorta;
                emp.descripcionLarga = e.descripcionLarga;
                lista.push(emp);
              });
            }
            return lista;
          })
        );
    } catch (e) {
      console.error('ServicioFormatoAsistencialService.getEmpresasByAdmision()', e);
    }
  }

  async getTratamientosByAdmision(codigoBaseDatos: string, admision: number) {
    try {
      return await this.requestUrl.getFilterRequest('formato-asistencial/ttas-by-admision', [ codigoBaseDatos, {
        admision: admision
      }]);
    } catch (e) {
      console.error('ServicioFormatoAsistencialService.getgetTratamientosByAdmision()', e);
    }
  }

  async getHeaderFormatoAsistencial(codigoBaseDatos: string, tta: number) {
    try {
      const response = await this.requestUrl.getRequest('formato-asistencial/header', [ codigoBaseDatos, { tta : tta}]);
      return response;
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getHeaderFormatoAsistencial()', e);
    }
  }

  async getLogoEntidadEmpresarial(codigoBaseDatos: string, params: any) {
    try {
      return await this.requestUrl.getImagesRequest('consultar/logo-entidad', [codigoBaseDatos, params]);
    } catch (e) {
      console.log('Error obteniendo logo', e);
    }
  }

  async getFirmaProfesional(codigoBaseDatos: string, params: any) {
    try {
      return await this.requestUrl.getImagesRequest('consultar/firma-profesional', [codigoBaseDatos, params]);
    } catch (e) {
      console.log('Error obteniendo firma profesional', e);
    }
  }

  async getFirmaAfiliado(codigoBaseDatos: string, params: any) {
    try {
      return await this.requestUrl.getImagesRequest('consultar/firma-afiliado', [codigoBaseDatos, params]);
    } catch (e) {
      console.log('Error obteniendo firma afiliado', e);
    }
  }

  async getDataFormatoAsistencial(codigoBaseDatos: string, tta: number) {
    try {
      return await this.requestUrl.getRequest('formato-asistencial/data', [ codigoBaseDatos, { tta: tta }]);
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getDataFormatoAsistencial()', e);
    }
  }

  async getControlDiagnosticoAsistencial(codigoBaseDatos: string, tta: number) {
    try {
      return await this.requestUrl.getRequest('formato-asistencial/control-dx', [ codigoBaseDatos, { tta: tta }]);
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getControlDiagnosticoAsistencial()', e);
    }
  }

  async getSignosVitalesAsistencial(codigoBaseDatos: string, tta: number) {
    try {
      return await this.requestUrl.getRequest('formato-asistencial/signos-vitales', [ codigoBaseDatos, { tta : tta }]);
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getSignosVitalesAsistencial()', e);
    }
  }

  async getHistoriaDiagnosticos(codigoBaseDatos: string, tta: number) {
    try {
      return await this.requestUrl.getRequest('formato-asistencial/historia-lista-dx', [ codigoBaseDatos, { tta : tta }]);
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getHistoriaDiagnosticos()', e);
    }
  }

  async getNotas(codigoBaseDatos: string, tta: number) {
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/notas`;
      const body: any = {
        codigoBaseDatos,
        tta,
        nodo: {}
      };
      return await this.http.post(url, body, { headers : this.HEADERS});
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getNotas()', e);
    }
  }

  async getEvoluciones(codigoBaseDatos: string, tta: number) {
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/tratamientos-evoluciones`;
      const body: any = {
        codigoBaseDatos,
        tta,
        nodo: {}
      };
      return await this.http.post(url, body, { headers : this.HEADERS});
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getEvoluciones()', e);
    }
  }

  async getOdontograma(codigoBaseDatos: string, tta: number, nodo: number) {
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/odontograma`;
      const body: any = {
        codigoBaseDatos : codigoBaseDatos,
        tta : tta,
        nodo: {
          id : nodo
        }
      };
      return await this.http.post(url, body, { headers : this.HEADERS});
    } catch (e) {
      console.log('ServicioFormatoAsistencialService.getOdontograma()', e);
    }
  }

  async getImagenNodo(codigoBaseDatos: string, entidad: number, tta: number, nodo: number) {
    try {
      const url = `${environment.API_IMAGENES}/consultar/nodo`;
      const body: any = {
        codigoBaseDatos : codigoBaseDatos,
        parametrosFiltros : {
          uncoEntidad : entidad,
          tta : tta,
          idNodo : nodo
        }
      };
      return await this.http.post(url, body, { headers : this.HEADERS });
    } catch (e) {
      console.error(`ServicioFormatoAsistencialService.getImagenNodo()`, e);
    }
  }

  // Auxiliares
  getNodosHijos(nodo: NodoEntity) {
    return this.nodosCompletos.filter((n: NodoEntity) => {
      const exist: boolean = n.padreNodo === nodo.id;
      return exist;
    });
  }

  getData(nodo: NodoEntity): DatoEntity[] {
    if (this.datosCompletos && this.datosCompletos.length > 0) {
      return this.datosCompletos.filter((d: DatoEntity) => d.idNodoPrincipal === nodo.id);
    } else {
      return [];
    }
  }

  setTemporalWait(nodo: NodoEntity, state: boolean): void {
    const KEY_TEMPORAL_WAIT = 'T_N_W';
    const obj = sessionStorage.getItem(KEY_TEMPORAL_WAIT);
    if (obj) {
      if (state) {
        const data: {id: number, title: string}[] = JSON.parse(obj);
        data.push({ id : nodo.id, title : nodo.titulo });
        this.theItem = JSON.stringify(data);
      } else {
        const data: {id: number, title: string}[] = JSON.parse(obj);
        const newData: {id: number, title: string}[] = [];
        data.forEach((el) => {
          if (el.id !== nodo.id) {
            newData.push({ id : el.id, title : el.title });
          }
        });
        this.theItem = JSON.stringify(newData);
      }
    } else {
      if (state) {
        const data = [];
        data.push({
          id : nodo.id,
          title : nodo.titulo
        });
        this.theItem = JSON.stringify(data);
      }
    }
  }

  getTemporalWait(): string | null {
    let str: string = null;
    const obj = this.theItem;
    if (obj) {
      const data: {id: number, title: string}[] = JSON.parse(obj);
      if (data && data.length > 0) {
        str = '';
        data.forEach((el) => str += str.length > 0 ?  `, ${el.title}` : el.title);
      }
    }
    return str;
  }

  clearTemporalWait(): void {
    const KEY_TEMPORAL_WAIT = 'T_N_W';
    sessionStorage.removeItem(KEY_TEMPORAL_WAIT);
  }

  set theItem(value: string) {
    sessionStorage.setItem('T_N_W', value);
    this.temporalNodos.next(value);
  }

  get theItem() {
    return sessionStorage.getItem('T_N_W');
  }

}

// Interfaces

export interface FiltrosFormatoAsistencialEntity {
  codigoBaseDatos ?: string;
  diligenciados ?: boolean;
  evoluciones ?: boolean;
  solicitudServicios ?: boolean;
  firmaProfesional ?: boolean;
  firmaAfiliado ?: boolean;
  notas ?: boolean;
  archivo ?: boolean;
  sede: number;
  uncoLogin ?: number;
  tta ?: number;
  marcaAgua ?: string;
  user: string;
  parametroSimens ?: ParametroSimens;
  entidadEmpresarial ?: EntidadEmpresarialEntity;
  login ?: LoginEntity;
  canLoad ?: boolean;
  canImpresion ?: boolean;
  pregunta ?: number;
}

export interface FormatoAsistencialEntity {
  unco: number;
  type: string;
  fechaAtencion: number;
  afiliado: AfiliadoEntity;
  empresa: EmpresaEntity;
  sedePuntoAtencion: SedePuntoAtencionEntity;
  lineaProducto: LineaProductoEntity;
  transaccion: TransaccionEntity;
  estadoRegistro: EstadoRegistroEntity;
  profesionalEspecialidad: ProfesionalEspecialidadEntity;
  filtros ?: FiltrosFormatoAsistencialEntity;
}

export interface FormatoAsistencialDataEntity {
  nodos: NodoEntity[];
  datos: DatoEntity[];
  valores: ValorPreguntaEntity[];
}

interface AfiliadoEntity {
  unco: number;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  fechaNacimiento: number;
  tipoDocumento: string;
  numeroIdentificacion: string;
  codigoSexo: string;
  direccion: string;
  celular: string;
  telefono: string;
  email: string;
  nombreResponsable: string;
  direccionResponsable: string;
  telefonoResponsable: string;
  edad: EdadEntity;
}

interface EdadEntity {
  anos: number;
  meses: number;
  dias: number;
}

interface EmpresaEntity {
  descripcionCorta: string;
  descripcionLarga: string;
}

interface SedePuntoAtencionEntity {
  sede: SedeEntity;
  puntoAtencion: PuntoAtencionEntity;
}

interface SedeEntity {
  numeroIdentificacion: string;
  descripcionCorta: string;
  descripcionLarga: string;
}

interface PuntoAtencionEntity {
  descripcion: string;
}

interface LineaProductoEntity {
  descripcion: string;
}

interface TransaccionEntity {
  prefijo: string;
  consecutivo: string;
}

interface EstadoRegistroEntity {
  descripcion: string;
}

interface ProfesionalEspecialidadEntity {
  unco: number;
  profesional: ProfesionalEntity;
  especialidad: EspecialidadEntity;
}

interface ProfesionalEntity {
  unco: number;
  nombres: string;
  apellidos: string;
  registroMedico: string;
}

interface EspecialidadEntity {
  descripcion: string;
}

interface ParametroSimens {
  activaResponsable: boolean;
}

export interface NodoEntity {
  id: number;
  padreNodo: number;
  titulo: string;
  codigo: string;
  obligatorio: boolean;
  orden: number;
  valor: string;
  codigoOrientacion: number;
  codigoEstructura: number;
  codigoTipoObjeto: number;
  impresion: boolean;
  hijos ?: NodoEntity[];
  datos ?: DatoEntity[];
  descripcion: string;
  notas ?: NotaEntity[];
}

export interface DatoEntity {
  id: number;
  idNodoPrincipal: number;
  idNodoRelacionado1: number;
  idNodoRelacionado2: number;
  valor: string;
  index: number;
}

export interface ValorPreguntaEntity {
  unco: number;
  descripcion: string;
  descripcionDetallada: string;
}

export interface HistoriaDiagnostico {
  id ?: number;
  uncoHistoriaClinica ?: number;
  index ?: number;
  diagnostico ?: { unco: number, codigoDiagnostico: string, descripcion: string };
}

export interface NotaEntity {
  id: number;
  idNodo: number;
  idTta: number;
  nota: string;
}

export interface TratamientoAsistencialEntity {
  id: number;
  uncoHistoriaClinica: number;
  uncoRelacionCronologicaEvolucion: number;
  historia: boolean;
  evolucion: boolean;
}

export interface OdontogramaValueEntity {
  permanentes: number;
  temporales: number;
  cariados: number;
  obturados: number;
  perdidosExtraidos: number;
  sanos: number;
  indiceCeo: string;
  indiceCop: string;
  ipb: string;
  ipbMessage: string;
}

// Enums

export enum TipoObjeto {
  CasillaVerificacion = 1,
  ListaDesplegable = 2,
  Imagenes = 3,
  SeleccionUnica = 4,
  CuadroTexto = 5,
  AreaTexto = 6,
  Tabla = 7,
  Matriz = 8,
  Fecha = 9,
  FechaHora = 10,
  Spinner = 11,
  Rango = 12,
  Formula = 13,
  Dermatomas = 19,
  Acordion = 24,
  Panel = 25,
  MatrizAgrupamiento = 26,
  Numero = 27,
  Label = 29,
  Diagnostico = 30,
  Editor = 32,
  CIE10 = 33,
  Odontograma = 35,
  Datasource = 37,
  SignosVitales = 38,
  Condicion = 39,
  TablaDx = 42,
  AudiometriaTonal = 43,
  AudiometriaVocal = 44
}

export enum Operador {
  Suma = 1,
  Resta = 2,
  Multiplicacion = 3,
  Division = 4,
  Potencia = 5
}

export enum EstructuraNodo {
  Grupo = 1,
  Pregunta = 2,
  Encabezado = 3,
  Respuesta = 4
}
